var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34663 16C4.8681 16 4.5 15.6318 4.5 15.153C4.5 14.9229 4.60123 14.7112 4.74847 14.5547L11.4387 8L4.74847 1.44534C4.60123 1.28884 4.5 1.06789 4.5 0.846951C4.5 0.368239 4.8681 0 5.34663 0C5.57669 0 5.78834 0.0920598 5.94479 0.257768L13.2331 7.3832C13.408 7.5397 13.5 7.76064 13.5 8C13.5 8.23015 13.408 8.44189 13.2331 8.6168L5.94479 15.7514C5.77914 15.9079 5.57669 16 5.34663 16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRight.25f16bcf36ed58a6845ee96b0c7756d2.svg";